module.exports = __webpack_public_path__ + "static/media/29ADMSPC27.55f3399e.jpg";